import { get } from 'lodash';
import { pruneFieldErrors } from '@/utils/errors';
import findResult, {
  jsonTryParse, hasKey, selectableResult, findWithCode,
} from '@/utils/resultsHelper';
import uuidHelper, { addUUIDsToArray } from '@/utils/uuidHelper';
import pagingWithFilteredResults, { presentationOptions } from '@/constants/states';
import fields from '@/constants/fields';
import { vocabularyCategories, vocabularyGroupings, vocabularyStates } from '../constants';

export const emailTemplate = {
  cc: '',
  bcc: '',
  subject: '',
  body: '',
};

export const activeVocabulary = () => ({
  open: false,
  code: null,
  name: '',
  value: '',
  grouping: null,
  urls: [],
  email: emailTemplate,
  roleActions: [],
  ...vocabularyStates,
});

export const newVocabularyProperties = (item, action) => ({
  ...item,
  code: action.code,
  category: action.category,
  open: true,
  ...vocabularyStates,
});

export const newVocabularyLink = () => (
  {
    uuid: uuidHelper.generate(),
    name: '',
    href: '',
    target: '',
    description: '',
  }
);

export const newVocabularyRoleAction = () => (
  {
    uuid: uuidHelper.generate(),
    name: '',
    href: '',
    title: '',
    target: '',
    content: '',
  }
);

const adminVocabularies = (display = presentationOptions.TABLE) => (
  {
    admin: {
      ...pagingWithFilteredResults(),
      ...vocabularyStates,
      display,
    },
  }
);

const initialState = {
  activeVocabulary: activeVocabulary(),
  vocabularies: {
    ...adminVocabularies(),
    all: {
      ...pagingWithFilteredResults(1000),
      ...vocabularyStates,
    },
  },
};

export const pruneVocabularyErrors = (errors, { properties }) => {
  let filteredErrors = errors;

  if (hasKey(properties, 'value')) {
    filteredErrors = pruneFieldErrors(filteredErrors, fields.VALUE);
  }

  return filteredErrors;
};

export const vocabulariesResult = (result) => {
  if ([vocabularyGroupings.URLS, vocabularyGroupings.CUSTOM_LINKS].includes(result.grouping)) {
    const urls = jsonTryParse(result.value, []);
    return { ...selectableResult(result), urls: addUUIDsToArray(urls) };
  }

  if ([vocabularyGroupings.EMAIL_TEMPLATE].includes(result.grouping)) {
    const email = { ...emailTemplate, ...jsonTryParse(result.value, emailTemplate) };
    return { ...selectableResult(result), email };
  }

  if ([vocabularyGroupings.ROLE_ACTIONS].includes(result.grouping)) {
    const roleActions = addUUIDsToArray(jsonTryParse(result.value, []));
    return { ...selectableResult(result), roleActions };
  }

  return {
    ...selectableResult(result), urls: [], email: emailTemplate,
  };
};

export const findVocabularies = ({ vocabularies }, { category }) => vocabularies[category];

export const findAllVocabularies = ({ vocabularies }, { code }) => (
  findWithCode(vocabularies, vocabularyCategories, code)
);

export const findVocabulary = ({ vocabularies }, { category, code }) => findResult(vocabularies, category, code);

export const vocabularyStateToLoad = ({ vocabularies }) => {
  const items = get(vocabularies, 'vocabularies', initialState.vocabularies);
  const adminFilters = items.admin || initialState.vocabularies.admin;

  return {
    ...initialState,
    vocabularies: {
      ...initialState.vocabularies,
      ...adminVocabularies(adminFilters.display),
    },
  };
};

export const vocabularyStateToSave = ({ vocabularies }) => (
  {
    vocabularies: {
      vocabularies: {
        admin: {
          display: vocabularies.vocabularies.admin.display,
        },
      },
    },
  }
);

export default initialState;
